import { ACTIVE_SERVER_ID } from 'mk/settings';

export const RECIPES_TEST_USER_ID = {
    201: 629922,
    202: 629922,
}[ACTIVE_SERVER_ID];
